import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index'

var eraValues = {
  "abbreviated": [
    "BCE",
    "CE",
  ],
  "narrow": [
    "BCE",
    "CE",
  ],
  "wide": [
    "BCE",
    "CE",
  ],
}

var quarterValues = {
  "abbreviated": [
    "Q1",
    "Q2",
    "Q3",
    "Q4",
  ],
  "narrow": [
    "1",
    "2",
    "3",
    "4",
  ],
  "wide": [
    "Q1",
    "Q2",
    "Q3",
    "Q4",
  ],
}

var formattingQuarterValues = quarterValues

var monthValues = {
  "abbreviated": [
    "Jasyteĩ",
    "Jasykõi",
    "Jasyapy",
    "Jasyrundy",
    "Jasypo",
    "Jasypoteĩ",
    "Jasypokõi",
    "Jasypoapy",
    "Jasyporundy",
    "Jasypa",
    "Jasypateĩ",
    "Jasypakõi",
  ],
  "narrow": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
  ],
  "wide": [
    "Jasyteĩ",
    "Jasykõi",
    "Jasyapy",
    "Jasyrundy",
    "Jasypo",
    "Jasypoteĩ",
    "Jasypokõi",
    "Jasypoapy",
    "Jasyporundy",
    "Jasypa",
    "Jasypateĩ",
    "Jasypakõi",
  ],
}

var formattingMonthValues = monthValues

var dayValues = {
  "abbreviated": [
    "Arateĩ",
    "Arakõi",
    "Araapy",
    "Ararundy",
    "Arapo",
    "Arapoteĩ",
    "Arapokõi",
  ],
  "narrow": [
    "S",
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
  ],
  "short": [
    "Arateĩ",
    "Arakõi",
    "Araapy",
    "Ararundy",
    "Arapo",
    "Arapoteĩ",
    "Arapokõi",
  ],
  "wide": [
    "Arateĩ",
    "Arakõi",
    "Araapy",
    "Ararundy",
    "Arapo",
    "Arapoteĩ",
    "Arapokõi",
  ],
}

var formattingDayValues = dayValues

var dayPeriodValues = {
  "abbreviated": {
    "afternoon": undefined,
    "am": "AM",
    "evening": undefined,
    "midnight": undefined,
    "morning": undefined,
    "night": undefined,
    "noon": undefined,
    "pm": "PM",
  },
  "narrow": {
    "afternoon": undefined,
    "am": "AM",
    "evening": undefined,
    "midnight": undefined,
    "morning": undefined,
    "night": undefined,
    "noon": undefined,
    "pm": "PM",
  },
  "wide": {
    "afternoon": undefined,
    "am": "AM",
    "evening": undefined,
    "midnight": undefined,
    "morning": undefined,
    "night": undefined,
    "noon": undefined,
    "pm": "PM",
  },
}

var formattingDayPeriodValues = dayPeriodValues

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  return dirtyNumber
}

var localize = {
  ordinalNumber: ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    formattingValues: formattingQuarterValues,
    argumentCallback: function(quarter) {
      return Number(quarter) - 1
    }
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayValues,
    defaultFormattingWidth: 'wide'
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
}

export default localize
